export default "__VITE_ASSET__BFQjEPeA__"